module.exports = __webpack_public_path__ + "static/media/3.1e40a98e.jpg";